import supportModule from '../../support.module';

export default supportModule.component('supportOverview', {
    template: require('./supportOverview.component.html')
});



// WEBPACK FOOTER //
// ./modules/support/components/support-overview/supportOverview.component.js